import { DynamicAttributeFieldEnum } from "./dynamic-attribute-field-enum/dynamic-attribute-field-enum";
import { AnyInput } from "./dynamic-attribute-field-input-types";
import { DynamicAttributeFieldReference } from "./dynamic-attribute-field-reference/dynamic-attribute-field-reference";
import { DynamicAttributeFieldSimple } from "./dynamic-attribute-field-simple/dynamic-attribute-field-simple";
import { DynamicAttributeFieldFragment } from "gql/graphql";
import { DynamicAttributeFieldLocalized } from "@/shared/dynamic-attributes/ui/dynamic-attribute-field/dynamic-attribute-field-localized/dynamic-attribute-field-localized";

export function DynamicAttributeFieldInput({
  meta,
  ...rest
}: AnyInput<{
  meta: DynamicAttributeFieldFragment;
}>) {
  switch (meta.__typename) {
    case "SimpleTypeDynamicAttributeDto":
      return <DynamicAttributeFieldSimple meta={meta} {...rest} />;
    case "ReferenceTypeDynamicAttributeDto":
      return <DynamicAttributeFieldReference meta={meta} {...rest} />;
    case "EnumTypeDynamicAttributeDto":
      return <DynamicAttributeFieldEnum meta={meta} {...rest} />;
    case "LocalizedValueDynamicAttributeDto":
      return <DynamicAttributeFieldLocalized meta={meta} {...rest} />;
    default:
      throw new Error(`Unknown dynamic attribute type`);
  }
}
